module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAo0lEQVQ4y2NgGBTg/5Ej/6Oq9/4/cuH5///h4WDaMW3zf5A4g/FM3BgGQJpBipENAPFBhiBr+Pz1F3YD/gPB379//4MB0ABkQJQLwJpgWE7uPzIfm8anr76gGgDzL4oXVqz439u/F1UDThdMn/7fr3AHigHVXfuxBmL7/POYBuD1JzFhgNV/5BgA0vzv3///xy+9wKoBZzTi9CM5XiAvDIY0AAA8MF5K5gdi1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AU.png
// module id = 1080
// module chunks = 0